import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import Popover from '@softwaredev_cegeka/stix-core/dist/components/Popover'
import ThemeContext from '@softwaredev_cegeka/stix-core/dist/components/ThemeProvider/ThemeContext'
import PlaceholderImage from '@softwaredev_cegeka/stix-core/dist/components/PlaceholderImage'

import MainMenu from 'src/components/Menu/MainMenu'

import withTranslations from 'src/HOCs/withTranslations'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
import styles from './sidebar.module.scss'

class Sidebar extends Component {
    static contextType = ThemeContext

    handleCollapse = () => {
        const mediaQuery = window.matchMedia('(min-width: 768px)')
        if (!mediaQuery.matches) {
            this.props.onCollapse(true)
        }
        // Check if local storage exists and save preference;
        else if (this.props.collapsed) {
            this.props.onCollapse(false)
        } else {
            this.props.onCollapse(true)
        }
    }

    collapseSidebar() {
        const mediaQuery = window.matchMedia('(min-width: 768px)')
        if (!mediaQuery.matches) {
            return true
        }
        const horizonMenuExpanded = localStorage.getItem(
            'horizon_menu_expanded'
        )
        return !parseInt(horizonMenuExpanded)
    }

    componentDidMount() {
        this.props.onCollapse(this.collapseSidebar())
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props
        if (prevProps.location.pathname !== location.pathname) {
            this.props.onCollapse(this.collapseSidebar())
        }
    }

    isEnv = environment => {
        const basePathWithProtocol = window.location.hostname
        const basePath = basePathWithProtocol.replace(/^https?:\/\//, '')
        return getEnvVariableValue(environment) === basePath
    }

    // TODO: fix popover to have only a title or a body. The custom css prevents configuration.
    render() {
        const { t, collapsed } = this.props
        return (
            <div className={styles.wrapper}>
                <Popover
                    placement="right"
                    content={
                        collapsed
                            ? t('Expand side menu')
                            : t('Collapse side menu')
                    }
                    title={' '}
                    delay={{ show: 2000, hide: 100 }}
                    className={styles.info}
                >
                    <button
                        className={styles.btnCollapse}
                        onClick={this.handleCollapse}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                </Popover>
                <div className={styles.container}>
                    <NavLink to={'/'} className={styles.logo}>
                        <PlaceholderImage
                            src={
                                this.context.activeTheme?.config
                                    ?.applicationLogo ??
                                this.context.activeTheme?.config?.logo
                            }
                            alt={t('Go to the homepage')}
                        />
                    </NavLink>
                    <section className={styles.section}>
                        <MainMenu parentIsCollapsed={collapsed} />
                        <div className={styles.transparentLogoWrapper}>
                            <span className={styles.transparentLogoText}>
                                Powered by
                            </span>
                            <img
                                className={cx(styles.transparentLogo, {
                                    [styles.vesselCollapsed]:
                                        collapsed &&
                                        (this.isEnv(
                                            VARIABLES.NEXUZHEALTH_HOST
                                        ) ||
                                            this.isEnv(VARIABLES.CTG_HOST)),
                                })}
                                src={'/transparent-company-logo.svg'}
                                alt={t('company logo')}
                            />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

Sidebar.propTypes = {
    collapsed: PropTypes.bool,
    onCollapse: PropTypes.func,
}

export default withTranslations('Sidebar', 'Sidebar')(withRouter(Sidebar))
